import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";

export default function PrivacyPage() {
    return (
        <div data-testid="privacy-page">
            <PageHero
                eyebrow="About BENNE"
                title="Privacy Policy"
                lead="A plain-language summary of what we collect, why, and how to opt out. Last updated February 2026."
                breadcrumbs={[
                    { label: "Home", to: "/" },
                    { label: "About", to: "/about" },
                    { label: "Privacy" },
                ]}
            />
            <div className="px-4 md:px-8 lg:px-12 py-16 max-w-3xl font-sofia text-base text-[#1B1B1B]/85 leading-[1.8] space-y-6">
                <section>
                    <h2 className="font-poppins font-bold text-xl text-[#E63B26]">
                        What we collect
                    </h2>
                    <ul className="list-disc pl-6 mt-3 space-y-2">
                        <li>
                            <strong>Newsletter subscribers:</strong> email
                            address, signup timestamp.
                        </li>
                        <li>
                            <strong>Press release submissions:</strong> name,
                            email, business, headline, body and any optional
                            metadata you provide.
                        </li>
                        <li>
                            <strong>Server logs:</strong> standard request logs
                            (IP, user-agent, requested path) retained for 30 days
                            for security/abuse purposes.
                        </li>
                    </ul>
                </section>
                <section>
                    <h2 className="font-poppins font-bold text-xl text-[#E63B26]">
                        What we don't collect
                    </h2>
                    <p>
                        We don't run third-party advertising scripts. We don't
                        sell your data. We don't use ad-tech identifiers.
                    </p>
                </section>
                <section>
                    <h2 className="font-poppins font-bold text-xl text-[#E63B26]">
                        How to opt out
                    </h2>
                    <p>
                        Every newsletter contains a one-click unsubscribe. Use
                        our{" "}
                        <Link
                            to="/contact"
                            className="text-[#E63B26] underline hover:text-[#1B1B1B]"
                            data-testid="privacy-contact-link"
                        >
                            contact form
                        </Link>
                        {" "}to request data deletion at any time. We process
                        deletion requests within 7 business days.
                    </p>
                </section>
                <section>
                    <h2 className="font-poppins font-bold text-xl text-[#E63B26]">
                        Cookies
                    </h2>
                    <p>
                        We use a single first-party cookie to remember admin
                        sessions. No tracking cookies.
                    </p>
                </section>
                <section>
                    <h2 className="font-poppins font-bold text-xl text-[#E63B26]">
                        Children's privacy
                    </h2>
                    <p>
                        BENNE is intended for readers 16+. We do not knowingly
                        collect information from children under 16.
                    </p>
                </section>
            </div>
        </div>
    );
}
